import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Button from '../../../../components/Button';
import Card from '../../../../components/Card';
import Checkbox from '../../../../components/Checkbox';
import InlineNotice from '../../../../components/InlineNotice';
import PageHeader from '../../../../components/PageHeader';
import StickyPanel from '../../../../components/StickyPanel';
import { Gap } from '../../../../components/classNames';
import AppConfig from '../../../../config';
import { usePageContext } from '../../../../hooks/usePageContext';
import { t } from '../../../../lang';
import HelperService from '../../../../services/HelperService';
import RequestService from '../../../../services/RequestService';
import { appSlice, cardSlice } from '../../../../store/slices';

const { routes } = AppConfig;

const CloseCardConfirm = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { useSearchParams, useSelector } = usePageContext();

	const cardId = Number(useSearchParams().get('cardId'));
	const cardInfo = useSelector(store => store.card?.cardsList?.find(({ Id }) => Id === cardId));
	const closeCard = useSelector(({ card }) => card.closeCard);

	const handleConfirm = ({ target: { name, checked } }) => {
		dispatch(cardSlice.actions.closeCardSetConfirm({ cardId, name, value: checked }));
	};

	const { confirmDeleted, confirmLoseFounds, confirmNoHelp } = closeCard?.confirms ?? {};

	const isConfirmEnabled = confirmDeleted && confirmLoseFounds && confirmNoHelp;

	const confirm = () => {
		const requestData = { Id: cardId };
		const requestMethod = async data => {
			const result = await RequestService.CloseCard(data);
			return result;
		};
		const resolveFunc = response => {
			if (response?.Status === 'Success') {
				dispatch(appSlice.actions.setPinConfirm());
				dispatch(cardSlice.actions.closeCardFinish({ cardId }));
				navigate({ pathname: routes.mainPage, hash: String(cardId) });
				setTimeout(() => {
					navigate({ pathname: routes.mainPage });
					HelperService.showNotification({
						type: 'success',
						title: t('Successful'),
						description: t('The close card successful.'),
					});
				}, 2000);
			} else {
				navigate(-1);
			}
		};

		HelperService.confirmPin({ requestMethod, requestData, resolveFunc });
	};

	return (
		<div className='SubPageWrapper'>
			<PageHeader header={'Close card'} />
			<StickyPanel
				controls={
					<Button
						onClick={confirm}
						iconBefore={'VIEWFINDER_KEY'}
						className='iconCurrentColor'
						styleType='red'
						disabled={!isConfirmEnabled}
					>
						{t('Confirm')}
					</Button>
				}
			>
				<div className={`SubPageBody ${Gap.Large}`}>
					<InlineNotice icon='EXCLAMATIONMARK_CIRCLE' type='error'>
						{"This card will be permanently closed. You won't be able to use it again or restore access."}
					</InlineNotice>
					{cardInfo ? (
						<Card
							color={cardInfo.Color}
							Id={cardInfo.Id}
							number={cardInfo.Number}
							cardholderName={cardInfo.CardholderName}
							paymentSystem={cardInfo.PaymentSystem}
							status={'closing'}
						/>
					) : null}
					<Checkbox
						name='confirmDeleted'
						checked={confirmDeleted}
						label='I understand that deleting the card has permanently deleted it from my account.'
						onChange={handleConfirm}
						disabled={false}
					/>
					<Checkbox
						name='confirmLoseFounds'
						checked={confirmLoseFounds}
						label='I understand that deleting the card has permanently deleted it from my account.'
						onChange={handleConfirm}
						disabled={false}
					/>
					<Checkbox
						name='confirmNoHelp'
						checked={confirmNoHelp}
						label='I understand that deleting the card has permanently deleted it from my account.'
						onChange={handleConfirm}
						disabled={false}
					/>
				</div>
			</StickyPanel>
		</div>
	);
};

export default CloseCardConfirm;
